<template>
  <select @input="$emit('input', $event.target.value)">
    <option value :selected="!value || value.length === 0"></option>
    <option v-for="obj in uniqueObjects" v-if="obj.id" :value="obj.id">{{ obj.name }}</option>
  </select>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import Button from '../button'

  export default {
    props: {
      value: String,
      objects: Array
    },

    computed: {
      definedObjects: function() {
        return this.objects.filter(obj => obj)
      },

      uniqueObjects: function() {
        let uniqueIds = [ ...new Set(this.definedObjects.map(obj => obj.id)) ]

        return uniqueIds.map(id => {
          return this.definedObjects.find(obj => obj.id == id)
        })
      },
    }
  }
</script>

<style scoped lang="scss">
</style>
